<template>
	<aside
		v-show="list.length"
		class="notifications"
		:aria-label="$t('global-notification-center-label')"
	>
		<ol class="notifications-list">
			<li v-for="[id, item] in list" :key="id">
				<TStatusMessage
					class="notifications-message"
					:type="item.type"
					:link="item.link"
					:aria-label="$t('global-status-message')"
					closeable
					@close="notificationsStore.remove(id)"
					@pointerenter="notificationsStore.stopTimer(id)"
					@pointerleave="notificationsStore.startTimer(id)"
				>
					<p>{{ item.text }}</p>
				</TStatusMessage>
			</li>
		</ol>
	</aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import TStatusMessage from '@/app/common/TStatusMessage.vue'
import { useNotificationsStore } from '@/shared/stores/notifications.ts'

const notificationsStore = useNotificationsStore()
const list = computed(() => [...notificationsStore.list].toReversed())
</script>

<style scoped>
.notifications {
	inline-size: calc(33.75rem + var(--app-edge-spacing) * 2);
	inset-block-start: var(--header-block-size);
	inset-inline-end: 0;
	max-block-size: calc(100% - var(--header-block-size));
	max-inline-size: 100%;
	overflow-y: auto;
	overscroll-behavior: contain;
	padding-block: var(--size-16);
	padding-inline: var(--app-edge-spacing);
	position: fixed;
	z-index: var(--z-index-notification-center);
}

.notifications-list {
	display: flex;
	flex-direction: column;
	gap: var(--size-16);
}

.notifications-message {
	box-shadow: var(--u-popover-shadow);
	inline-size: 100%;
}
</style>
